<template>
    <div id="app">
        <router-view/>
    </div>
</template>


<script>
export default {
  data() {
    return {
    };
  },
  created() {
    
  },
  mounted() {
    let URL = 'https://xymb.xyyysp.com/#/'
    if (window.screen.width < 500) {
      let a = document.createElement('a');
      a.href = URL;
      a.click();
    }
  },
  destroyed() {
  },
  methods: {
    
  },
};
</script>


<style lang="less">
    html, body {
        height: 100%;
    }
    @import "./style/init.less";
    * {
        box-sizing: border-box !important;
        font-size: 16px;
    }

    /*div::-webkit-scrollbar {*/
    /*    display: none*/
    /*}*/
    *::-webkit-scrollbar {
        /*display: none; !* Chrome Safari *!*/
        height: 10px;
        width: 20px;
    }
    #app {
        min-width: 1200px;
        width: 100%;
        overflow-x: hidden;
        background-color: #f7f7f7;
        height: 100%;
        overflow-y: auto;
        /*background-color: #fff;*/
    }

    .w-view-shell {
        width: 1200px;
        margin: 0 auto;
    }

    .el-submenu__title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px !important;
        height: 100% !important;
    }

    .pointer, .handler {
        cursor: pointer;
    }

    .paging-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
    }

    /deep/ .el-menu-item.is-active {
        background-color: rgb(231, 235, 240) !important;
    }

    .information-html {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;

        ul, li {
            list-style: none;
            margin: 0 !important;
            padding: 0 !important;
            font-size: 18px !important;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 30px !important;

            code {
                font-size: 16px !important;
            }
        }
    }

    .show-line-1 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        -o-text-overflow: ellipsis; /* for Opera */
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .show-line-2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        -o-text-overflow: ellipsis; /* for Opera */
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .show-line-6 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        -o-text-overflow: ellipsis; /* for Opera */
        text-overflow: ellipsis;
        overflow: hidden;
    }

</style>
